import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import BoxedContainer from '../layouts/BoxedContainer';
import { dateToMonthStr, isCurrDate } from '../../helpers/handleDates';
import EventCard from '../event-card/EventCard';
import { fetchAllEvents } from '../../services/fetchAllEvents';
import { getAllEvents } from '../../services/getAllEvents';

async function getEvents() {
  try {
    const events = await fetchAllEvents();
    return events;
  } catch (error) {
    console.error('Error fetching events:', error);
    // Handle the error, e.g., show an error message
    return [];
  }
}

function EventsPaginated({ id }) {
  const [loadedGroupQty, setLoadedGroupQty] = useState(0);
  const [eventsPerGroupQty, setEventsPerGroupQty] = useState(2);
  const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const [events, setEvents] = useState([]);
  const [eventsByMonth, setEventsByMonth] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const graphQlEv = getAllEvents();

  useEffect(() => {
    async function fetchData() {
      const fetchedEvents = isEmpty(graphQlEv) ? await getEvents() : graphQlEv;

      setEvents(fetchedEvents);
      setIsLoading(false);
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (isEmpty(events)) return;

    const lastEndEvent = events
      .sort((a, b) => new Date(a.endDate) - new Date(b.endDate))
      .slice(-1)[0];
    const lastEndEventMonth = +new Date(lastEndEvent.endDate)
      .toISOString()
      .slice(0, 7)
      .replace(/-/g, '');

    const monthsInBetween = lastEndEventMonth - +today.slice(0, 6);
    const currMonth = +today.slice(4, 6);
    const eventsByMonthTemp = {};

    for (let index = currMonth; index <= currMonth + monthsInBetween; index += 1) {
      const tempMonth = index > 12 ? index - 12 : index;
      const tempYear = index > 12 ? +today.slice(0, 4) + 1 : +today.slice(0, 4);
      const key = `${tempYear}${tempMonth < 10 ? `0${tempMonth}` : tempMonth}`;
      eventsByMonthTemp[key] = events.filter((ev) => {
        const emptyDate = '0001-01-01T00:00:00Z';
        if (ev.startDate === emptyDate || ev.endDate === emptyDate) return true;
        return isCurrDate(ev.startDate, ev.endDate, +key.slice(4, 6), +key.slice(0, 4));
      });
    }

    setEventsByMonth(eventsByMonthTemp);
  }, [events, today]);

  useEffect(() => {
    if (isEmpty(eventsByMonth)) return;

    const hasMoreKeys = loadedGroupQty < Object.keys(eventsByMonth).length;
    const hasMoreEvents = eventsPerGroupQty < Object.values(eventsByMonth)[loadedGroupQty]?.length;
    if (!hasMoreEvents && hasMoreKeys) {
      setEventsPerGroupQty(2);
      setLoadedGroupQty((prev) => prev + 1);
    }
  }, [eventsByMonth, loadedGroupQty, eventsPerGroupQty]);

  return (
    <section id={id} className="w-full bg-bg-1 lg:pb-[116px] pb-[70px] pt-[36px]">
      <BoxedContainer>
        <div className="w-full flex flex-col md:gap-y-14 gap-y-8">
          {/* eslint-disable-next-line no-nested-ternary */}
          {isLoading ? (
            // Show loading indicator
            <div>Loading events...</div>
          ) : isEmpty(eventsByMonth) ? (
            // Show no events message
            <div>No events found.</div>
          ) : (
                Object.entries(eventsByMonth).map(([key, currEvents], index) => (
                  <div key={index} className="w-full flex flex-col md:gap-y-14 gap-y-6">
                    <div className="w-full md:px-[10%] px-4">
                      <h2
                        className="font-roboto-condensed-bold lg:text-2xl text-[25px] leading-7
                    uppercase relative">
                        {dateToMonthStr(key)}
                      </h2>
                    </div>
                    <div className="w-full flex flex-col gap-y-2">
                      {isEmpty(currEvents) ? (
                        // Show no events message for the current month
                        <div>No events for this month.</div>
                      ) : (
                         currEvents.map((event, index2) => (
                           <EventCard key={`${event.title}_${index2}`} data={event} />
                         ))
                       )}
                    </div>
                  </div>
                ))
              )}
          <div className="w-full pb-6 flex justify-center">
            {loadedGroupQty < Object.keys(eventsByMonth).length && (
              <button
                onClick={() => setEventsPerGroupQty((prev) => prev + 3)}
                type="button"
                aria-label="show-more"
                className="w-fit h-fit bg-red whitespace-pre text-[13px] text-white py-3 px-24
                uppercase font-bold show-more">
                Show More
              </button>
            )}
          </div>
        </div>
      </BoxedContainer>
    </section>
  );
}

export default EventsPaginated;
